import {isEmpty, map} from "lodash";
import React, {useState} from "react";
import {FileRead} from "../../../../declarations";
import {downloadFileVariables} from "../../../../helpers";
import {Container} from "../../../../ui";
import {DetailsSection} from "../components";
import {DocumentDetails} from "./DocumentDetails";

interface IAccountDocumentations {
  accountId: string;
  openDocuments: boolean;
  userFiles: FileRead[];
  downloadUserFiles: (variables: downloadFileVariables) => Promise<void | string>;
}

export const AccountDocumentations = ({
  accountId,
  openDocuments,
  userFiles,
  downloadUserFiles,
}: IAccountDocumentations) => {
  const [accountDocumentations, setAccountDocumentations] = useState<boolean>(openDocuments);

  if (isEmpty(userFiles)) return null;

  return (
    <DetailsSection title={"Account documents"} isOpen={accountDocumentations} setIsOpen={setAccountDocumentations}>
      <Container fullWidth sx={{gap: "20px", marginTop: "10px"}}>
        {map(userFiles, (file, index) => {
          return (
            <DocumentDetails
              key={`file-${index}`}
              file={file}
              downloadUserFiles={downloadUserFiles}
              accountId={accountId}
            />
          );
        })}
      </Container>
    </DetailsSection>
  );
};
